import * as React from 'react';
import Button from '@mui/material/Button';
import {useNotify} from "react-admin";
import {useFormContext} from "react-hook-form";
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function WeblinkPreview({contentTypeTabIdx}: Readonly<{ contentTypeTabIdx: number }>) {
	const form = useFormContext();
	const {weblink} = form.getValues();
	const notify = useNotify();

	const handleClickOpen = () => {
		if(contentTypeTabIdx === 2){
			if(validateURL(weblink)){
				window.open(weblink, '_blank');
			} else {
				notify('請輸入正確的網址', { type: 'error' });
			}
		}
	};

	const validateURL = (value: string) => {
		let reg = /^(?:(http|https|ftp):\/\/)?((?:[\w-]+\.)+[a-z0-9]+)((?:\/[^/?#]*)+)?(\?[^#]+)?(#.+)?$/i;
		return reg.test(value);
	};

	return (
		<Button variant="contained"  onClick={handleClickOpen}>
			<VisibilityIcon/>預覽
		</Button>
	);
}
